import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'app/auth/service';
import { Route, Router } from '@angular/router';
import { NotificationService } from 'app/main/pages/_sommavi/services/notifications/notification.service';
import { UtilsService } from 'app/utils/utils.service';


// Interface
// interface notification {
//   messages: [];
//   systemMessages: [];
//   system: Boolean;
// }
interface notification {
  id: number;
  zone: number; 
  roles: string; 
  message: string; 
  status: string; //LU, NON LU
}

@Component({
  selector: 'app-navbar-notification',
  templateUrl: './navbar-notification.component.html'
})
export class NavbarNotificationComponent implements OnInit, OnDestroy {
  // Public
  public notifications: notification;

  currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  audio: HTMLAudioElement;
  /**
   *
   * @param {NotificationsService} _notificationsService
   */
  constructor(
    private _notificationsService: NotificationService,
    private _route: Router,
    private _authenticationService: AuthenticationService,

  ) {}

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */

  Notifications;
  NotificationsNbr: number = 0;
  ngOnInit(): void {
    //-> SUIT LA CONNEXION / DECONNEXION : (RE)ABONNEMENT AU FLUX AVEC LE COMPTE COURANT, SANS RECHARGER LA PAGE
    this.userSub = this._authenticationService.currentUser.subscribe(user => {
      if(this.fluxSub) this.fluxSub.unsubscribe();
      this.currentUser = user;
      this.Notifications = [];
      this.notifications = null;
      this.NotificationsNbr = 0;
      if(!user) return;
      this.getNotice();
      this.ecouterNotifications();
    });
    this.lectureSub = this._notificationsService.notificationsLues$.subscribe(() => this.getNotice());
    // UtilsService.ConfirmToast("Veuillez authoriser le sons pour les notifications !", () => this.launchNotificationListen())
    
    
  }

  // launchNotificationListen(){
  //   setInterval(() => {
  //     this.getNotice();
  //   }, 5000);
    
  // }

  getNotice(){
    if(!this.currentUser) return;
    const zones = JSON.parse(this.currentUser.magazinAction).map(item => {
      return +item.id
    });
    this._notificationsService.getAllnonLuNotifications(zones, this.currentUser.role).subscribe(res => {
      this.notifications = res;
      this.Notifications = res;
      this.NotificationsNbr = res.length;
      let count = 0;

      if(sessionStorage.getItem("notices")){
        if(res.length > 0){
          //check ids
          const notices = JSON.parse(sessionStorage.getItem("notices"));
          for(let note of res){
            if(!notices.includes(+note.id)){
              notices.push(+note.id);
              count = count + 1;
            }
          }
          if(count > 0){
            //read sons
            // const audio = new Audio();
            // console.log("read son -------");
            // audio.src = '../../../../../assets/audios/notification.mp3';
            // // this.audio.load();
            // audio.play();
          }
          sessionStorage.setItem("notices", JSON.stringify(notices));

        }
      }else{
        if(res.length > 0){
          const notices = res.map(item => {return +item.id});
          sessionStorage.setItem("notices", JSON.stringify(notices));
            //read sons
            // const audio = new Audio();
            // console.log("read son ------- first time");
            // audio.src = '../../../../../assets/audios/notification.mp3';
            // // this.audio.load();
            // audio.play();
        }
      }
      
    });
  }

  //-> TEMPS REEL : CHAQUE NOUVELLE NOTIFICATION ARRIVE PAR LE FLUX SSE, S'AJOUTE A LA CLOCHE ET JOUE LE SON
  fluxSub: Subscription;
  userSub: Subscription;
  lectureSub: Subscription;
  ecouterNotifications(){
    if(!this.currentUser) return;
    const zones = JSON.parse(this.currentUser.magazinAction).map(item => +item.id);
    this.fluxSub = this._notificationsService
      .fluxNotifications(zones, this.currentUser.role, () => this.getNotice())
      .subscribe(notice => {
        const liste = this.Notifications || [];
        if(liste.some(item => +item.id === +notice.id)) return;
        this.Notifications = [notice, ...liste];
        this.notifications = this.Notifications;
        this.NotificationsNbr = this.Notifications.length;
        this.memoriserNotice(+notice.id);
        this.jouerSon();
      });
  }

  memoriserNotice(id: number){
    const notices = JSON.parse(sessionStorage.getItem("notices") || "[]");
    if(!notices.includes(id)) notices.push(id);
    sessionStorage.setItem("notices", JSON.stringify(notices));
  }

  //-> LE NAVIGATEUR BLOQUE LE SON TANT QUE L'UTILISATEUR N'A PAS INTERAGI AVEC LA PAGE : ON IGNORE ALORS L'ERREUR
  jouerSon(){
    if(!this.audio) this.audio = new Audio('assets/audios/notification.mp3');
    this.audio.currentTime = 0;
    this.audio.play().catch(() => {});
  }

  ngOnDestroy(): void {
    if(this.fluxSub) this.fluxSub.unsubscribe();
    if(this.lectureSub) this.lectureSub.unsubscribe();
    if(this.userSub) this.userSub.unsubscribe();
  }

  goToNotices(){
    this._route.navigate(["pages/gestions/notifications"]);
  }
}
